/**
 * Puma
 * @category    ScandiPWA
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2021 Scandiweb, Ltd (https://scandiweb.com)
 */
import { getIndexedProduct } from 'Util/Product';

import { UPDATE_PRODUCT_DETAILS } from './Product.action';

export { formatConfigurableOptions } from 'SourceStore/Product/Product.reducer';

/** @namespace Scandipwa/Store/Product/Reducer/getInitialState */
export const getInitialState = () => ({
    product: {},
    content_html: [],
    formattedConfigurableOptions: {},
    showLengthError: false
});

/** @namespace Scandipwa/Store/Product/Reducer/ProductReducer */
export const ProductReducer = (
    state = getInitialState(),
    action
) => {
    switch (action.type) {
    case UPDATE_PRODUCT_DETAILS:
        const { product, content_html } = action;

        return {
            ...state,
            product: getIndexedProduct(product),
            content_html
        };

    default:
        return state;
    }
};

export default ProductReducer;
